import styled from '@emotion/styled';
import { Box } from './box';
import { css } from '@emotion/react';

export const Card = styled(Box)`
  border-radius: 4px;
`;

// Default props
Card.defaultProps = {
  padding: 'medium',
  backgroundColor: 'colorWhite',
};

export const Badge = styled(Box)`
  border-radius: 4px;
  width: fit-content;
  font-size: 10px;
`;

Badge.defaultProps = {
  padding: 'xs',
};

type DimAmount = 'low' | 'normal';

const dimAmountEnum = {
  low: 'var(--colorDimmerLight)',
  normal: 'var(--colorDimmerBackground)',
} as const;

export const Dimmer = styled(Box)<{ zIndex?: number; active: boolean; amount?: DimAmount }>`
  position: fixed;
  z-index: ${({ zIndex }) => zIndex || 3};
  top: 0%;
  left: 0%;
  bottom: 0%;
  right: 0;
  margin: 0;
  transition: opacity 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  opacity: ${({ active }) => (active ? 1 : 0)};
  ${({ active }) => !active && 'pointer-events: none'};
  background: ${({ amount }) => (amount ? dimAmountEnum[amount] : dimAmountEnum['normal'])};
`;
